module.exports = __webpack_public_path__ + "static/media/Office.a812641b.svg";